export default __webpack_public_path__ + "static/media/HelveticaNowDisplay-Bold.b3065eb5.otf";